export default __webpack_public_path__ + "static/media/construction.4bcf2360.svg";